import React, { Component } from 'react'
import JewelryPanel from '../jewelry-panel'
import SelectItem from '../../../components/select-item'
import Spacer from '../../../components/spacer'
import Slider from '../../../components/slider'
import HaloSideDiamondPanel from './halo-side-diamond-panel'
import {
  hideCentralHaloMilgrain,
  showPrimaryDiamondHaloPanel
} from '../../../utils/jewelry-validation'

class CentreHaloPanel extends Component {
  render () {
    const props = this.props

    const getCentreHaloWidthOptions = () => {
      return [...props.defaultHaloWidthOptions, {value: 'custom', label: 'Custom'}]
    }

    return (
      <JewelryPanel
        id='centreHaloPanel'
        show={showPrimaryDiamondHaloPanel(props)}
        isResetting={props.isResetting}>

        <Spacer lg />

        <SelectItem
          label='Centre Halo?'
          id='centreHaloSelect'
          labelId='centrehalo'
          options={[
            {value: false, label: 'No'},
            {value: true, label: 'Yes'}
          ]}
          value={props.has_central_halo}
          onChange={props.onChangeVal.bind(this, 'has_central_halo')}
          initVal={null}
        />

        <JewelryPanel
          id='centralHaloContentPanel'
          show={props.has_central_halo}
          isResetting={props.isResetting}>

          <Spacer xxs />

          <SelectItem
            id='central_halo_style'
            label='Centre Halo Type'
            labelId='centre_halo_style'
            options={[
              {value: 'single', label: 'Single'},
              {value: 'double', label: 'Double'}
            ]}
            value={props.central_halo_style}
            onChange={props.onChangeVal.bind(this, 'central_halo_style')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='centre_halo_width'
            label='Centre Halo Width (Per Row)'
            labelId='centreHaloWidth'
            options={getCentreHaloWidthOptions()}
            value={props.central_halo_width}
            onChange={props.onChangeVal.bind(this, 'central_halo_width')}
            initVal={null}
          />

          <JewelryPanel
            id='centralHaloCustomWidthPanel'
            show={props.central_halo_width === 'custom'}
            isResetting={props.isResetting}>

            <Spacer xxs />

            <h4>Centre Halo Custom Width</h4>
            <Slider
              id='central_halo_custom_width'
              labelRight='mm'
              single
              input
              min={1.0}
              max={5.0}
              step={0.1}
              value={props.central_halo_custom_width}
              onChange={props.onChangeVal.bind(this, 'central_halo_custom_width')}
              initVal={0}
            />
          </JewelryPanel>

          <Spacer xxs />

          <SelectItem
            id='centralHaloQuality'
            label='Quality of Diamonds in Centre Halo'
            labelId='centre_halo_diamond_quality'
            options={[
              {value: 'standard', label: 'Standard'},
              {value: 'plus', label: 'Plus'},
              {value: 'lab_grown', label: 'Lab Grown'},
            ]}
            value={props.central_halo_quality}
            onChange={props.onChangeVal.bind(this, 'central_halo_quality')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='central_halo_setting_style'
            label='Centre Halo Setting Style'
            labelId='centre_halo_setting_style'
            options={[
              {value: 'pave', label: 'Pavé'},
              {value: 'pave_border', label: 'Pavé w/ Border'},
              {value: 'channel_set', label: 'Channel Set'},
              {value: 'bezel_set', label: 'Bezel Set'},
              {value: 'shared_claw_set', label: 'Shared Claw'}
            ]}
            value={props.central_halo_setting_style}
            onChange={props.onChangeVal.bind(this, 'central_halo_setting_style')}
            initVal={null}
          />

          <Spacer xxs hide={hideCentralHaloMilgrain(props)} />

          <SelectItem
            label='Centre Halo Milgrain'
            id='centralHaloMilgrain'
            labelId='centre_halo_milgrain'
            options={[
              {value: 'no', label: 'No'},
              {value: 'yes', label: 'Yes'}
            ]}
            value={props.central_halo_milgrain}
            onChange={props.onChangeVal.bind(this, 'central_halo_milgrain')}
            hide={hideCentralHaloMilgrain(props)}
            initVal={null}
          />

          <HaloSideDiamondPanel {...props} onChange={props.onChangeVal} />
        </JewelryPanel>
      </JewelryPanel>
    )
  }
}

export default CentreHaloPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/centre-halo-panel/index.js